import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Combobox } from "@similarweb/ui-components";

export const StyledComboboxOption = styled(Combobox.Option)<{ $isBlockedByOtherCondition?: boolean }>`
    ${({ $isBlockedByOtherCondition }) =>
        $isBlockedByOtherCondition &&
        css`
            &,
            &:hover,
            &[data-hovered],
            &[data-focused],
            &:has([data-automation-checked="true"]) {
                background-color: ${colorsPalettes.carbon[0]} !important;
            }
        `}
`;
